import { observable, action } from "mobx";
import { db, firebase } from '../firebase';
import history from '../components/history';
import * as toastr from 'toastr';

// =====================================
// CONSTS
import { Messages } from "../const/Messages";

// =====================================
// STORES
import { commonStore } from "./CommonStore";

// =====================================
// MODELS
import { User } from "../models/User";

export interface ILoginStore {
    phoneNumber: string;
    code: string;
    fullName: string;
    vendorEmail: string;
    type: string;
    rememberMe: boolean;
    orgId: string;
    taxId: string;
    organizationName: string;

    isLoading: boolean;
    isPhoneNumberFormVisible: boolean;
    isCodeFormVisible: boolean;
    isRegistrationFormVisible: boolean;
    showWithdrawFromTheOrganizationButton: boolean;
    isSearchTaxIdVisible: boolean;
    isJoinOrganizationVisible: boolean;
    isRegisterAndJoinOrganizationButtonDisabled: boolean;

    phoneNumberMessage: string;
    codeMessage: string;
    fullNameMessage: string;
    vendorEmailMessage: string;
    taxIdMessage: string;

    init(type: string): void;
    onHandleChangeInput(event: any): void;
    onHandleChangeTaxId(event: any): void;
    withdrawFromTheOrganization();
    onSignInWithPhoneNumber(event): Promise<any>;
    onSubmitCode(event): Promise<any>;
    handleChangeRememberMe(event): void;
    onSignOut(): void;
    //onSaveRegistration(event): void;
    searchTaxId();
    registerAndJoinOrganization();
    changeTaxId();
    reset(): void;
}

export class LoginStore implements ILoginStore {
    constructor() {
        this.phoneNumber = "";
        this.code = "";
        this.fullName = "";
        this.vendorEmail = "";
        this.confirmationResult = null;
        this.recaptchaVerifier = undefined;
        this.type = "";
        this.rememberMe = false;
        this.orgId = "";
        this.taxId = "";
        this.organizationName = "";

        this.isLoading = true;
        this.isPhoneNumberFormVisible = true;
        this.isCodeFormVisible = false;
        this.isRegistrationFormVisible = false;
        this.showWithdrawFromTheOrganizationButton = false;
        this.isJoinOrganizationVisible = false;
        this.isSearchTaxIdVisible = false;
        this.isRegisterAndJoinOrganizationButtonDisabled = false;

        this.phoneNumberMessage = "";
        this.codeMessage = "";
        this.fullNameMessage = "";
        this.vendorEmailMessage = "";
        this.taxIdMessage = "";
    }

    @observable phoneNumber: string;
    @observable code: string;
    @observable uid: string;
    @observable fullName: string;
    @observable vendorEmail: string;
    @observable confirmationResult: any;
    @observable recaptchaVerifier: any;
    @observable type: string;
    @observable rememberMe: boolean;
    @observable orgId: string;
    @observable taxId: string;
    @observable organizationName: string;

    @observable isLoading: boolean;
    @observable isPhoneNumberFormVisible: boolean;
    @observable isCodeFormVisible: boolean;
    @observable isRegistrationFormVisible: boolean;
    @observable showWithdrawFromTheOrganizationButton: boolean;
    @observable isSearchTaxIdVisible: boolean;
    @observable isJoinOrganizationVisible: boolean;
    @observable isRegisterAndJoinOrganizationButtonDisabled: boolean;

    @observable phoneNumberMessage: string;
    @observable codeMessage: string;
    @observable fullNameMessage: string;
    @observable vendorEmailMessage: string;
    @observable taxIdMessage: string;

    @action init = (type: string): void => {
        //console.log("currentUser: ", firebase.auth().currentUser);
        if (typeof window !== "undefined") {
            window["recaptchaVerifier"] = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
                'size': 'invisible',
                'callback': (response) => {
                    // reCAPTCHA solved, allow signInWithPhoneNumber.
                    console.log("reCAPTCHA solved")
                }
            });
        }

        this.type = type;
        let currentUser = firebase.auth().currentUser;
        // if (currentUser && this.type === "register") {
        //     this.phoneNumber = commonStore.user.phoneNumber;
        //     this.isPhoneNumberFormVisible = false;
        //     this.isCodeFormVisible = false;
        //     this.isRegistrationFormVisible = true;
        //     this.isSearchTaxIdVisible = true;
        //     this.isJoinOrganizationVisible = false;
        // }
        this.isLoading = false;
        // this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
        //     "recaptcha-container",
        //     {
        //         size: "invisible"
        //     }
        // );
        //console.log(this.recaptchaVerifier);
    }

    @action onHandleChangeInput = (event: any): void => {
        const { name, value } = event.target;
        this[`${name}Message`] = "";
        this[name] = value;
    };

    @action onHandleChangeTaxId = (event: any): void => {
        if (event.target.value.length <= 9) {
            this.taxId = event.target.value;
        }
    };

    isValidPhoneNumber = (): boolean => {
        if (this.phoneNumber.charAt(0) === "0") {
            this.phoneNumber = `+381${this.phoneNumber.substring(1)}`;
        }
        else {
            this.phoneNumber = `+381${this.phoneNumber}`;
        }
        let pattern = /^\+[0-9\s\-\(\)]+$/;
        return this.phoneNumber.search(pattern) !== -1;
    }

    @action validatePhoneNumber = (): boolean => {
        let isValid: boolean = true;

        if (this.phoneNumber.trim() === "") {
            this.phoneNumberMessage = Messages.REQUIRED_FIELD;
            isValid = false;
        }

        return isValid;
    }

    @action onSignInWithPhoneNumber = async (event): Promise<any> => {
        event.preventDefault();
        if (!this.validatePhoneNumber()) return;

        if (this.isValidPhoneNumber()) {
            console.log(this.phoneNumber);
            const appVerifier = window["recaptchaVerifier"];
            try {
                this.isLoading = true;
                // this.confirmationResult = await firebase
                //     .auth()
                //     .signInWithPhoneNumber(this.phoneNumber, this.recaptchaVerifier);
                this.confirmationResult = await firebase
                    .auth()
                    .signInWithPhoneNumber(this.phoneNumber, appVerifier)

                // SMS sent. Prompt user to type the code from the message, then sign the
                // user in with confirmationResult.confirm(code).
                console.log("Code is sent");
                this.isLoading = false;
                this.isPhoneNumberFormVisible = false;
                this.isCodeFormVisible = true;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        } else {
            toastr.error(Messages.CHECK_CUSTOMER_PHONENUMBER);
        }
    };

    @action validateCode = (): boolean => {
        let isValid: boolean = true;

        if (this.code.trim() === "") {
            this.codeMessage = Messages.REQUIRED_FIELD;
            isValid = false;
        }

        if (this.code.trim().length > 6) {
            this.codeMessage = Messages.CODE_MAX_LENGTH;
            isValid = false;
        }

        return isValid;
    }

    @action withdrawFromTheOrganization = async () => {
        await db.collection("organizations").doc(this.orgId)
            .collection("users").doc(this.uid).update({
                userRequestedRemoval: true
            });
        toastr.success(Messages.WITHDRAW_FROM_THE_ORGANIZATION_SUCCESSFULL);
        this.onSignOut();
    }

    @action getUserFromOrganizationColl = async (userId: string, orgId: string) => {
        return await db.collection("organizations").doc(orgId)
            .collection("users").doc(userId).get();
    }

    @action loginUser = async () => {
        if (this.rememberMe) {
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        } else {
            await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
        }
        //await this.notifyMe();
        commonStore.setLocalStorageItem("isUserLoggedIn", "true");
        commonStore.isUserLoggedIn = true;

        history.push('/customers');
    }

    @action notifyMe = async () => {
        if (Notification.permission === "granted") {
            // If it's okay let's create a notification
            var notification = new Notification("Hi there!");
            console.log(Notification.permission);
            //await this.getFCMToken();
        } else if (Notification.permission === "denied") {
            const permission = await Notification.requestPermission();
            // If the user accepts, let's create a notification
            if (permission === "granted") {
                var notification = new Notification("Hi there!");
                //await this.getFCMToken();
            }
            console.log(Notification.permission);
        }
    }

    @action getFCMToken = async () => {
        // // try {
        // const messaging = firebase.messaging();
        // //await messaging.usePublicVapidKey("BMAmRh5yw80NHoUnMDGT0PMagj4ICNoudwCisfndU3LpHexZvjKPHLRgWpjIbpk5PxVpyfK8MYxbCbMCvvONIUo");
        // const fcmToken = await messaging.getToken();
        // // const fcmToken = await messaging.getToken({ vapidKey: "BMAmRh5yw80NHoUnMDGT0PMagj4ICNoudwCisfndU3LpHexZvjKPHLRgWpjIbpk5PxVpyfK8MYxbCbMCvvONIUo" });
        // console.log(fcmToken);
        // // }
        // // catch (e) {

        // // }
    }

    @action isUserSalesRep = async () => {
        let userInOrganizationSnap = await this.getUserFromOrganizationColl(commonStore.user.id, commonStore.user.orgId);
        if (userInOrganizationSnap.exists) {
            let userInOrganization = userInOrganizationSnap.data();
            if (userInOrganization.roles.find(role => role === "SALESREP")) {
                // if (userInOrganization.isSalesRep) {
                // LOGUJEMO KORISNIKA
                commonStore.user = userInOrganization as any;
                await this.loginUser();
            } else {
                // KONTAKTIRAJTE VASEG POSLODAVCA ILI ISTUPITE IZ ORGANIZACIJE
                /*prikazemo poruku - kontaktirajte vaseg poslodavca {{naziv organizacije}}, 
                i dugme - istupi iz organizacije (ako pritisne istupi iz organizacije, 
                u kolekciji /organizations/{orgId}/users/{userId} upisuje se atribut userRequestedRemoval: TRUE)*/
                const organizationSnap = await db.collection("organizations").doc(commonStore.user.orgId).get();
                let organizationName = "";
                if (organizationSnap.exists) {
                    organizationName = organizationSnap.data().name;
                }
                toastr.error(`${Messages.CONTACT_YOUR_VENDOR} ${organizationName}`);
                this.showWithdrawFromTheOrganizationButton = true;
                this.uid = commonStore.user.id;
                this.orgId = commonStore.user.orgId;
                this.isLoading = false;
            }
        } else {
            // Sta ako user ne postoji u /organizations/{orgId}/users/
        }
    }

    @action handleChangeRememberMe = (event): void => {
        this.rememberMe = event.target.checked;
    }

    @action onSubmitCode = async (event) => {
        event.preventDefault();
        if (!this.validateCode()) return;

        this.isCodeFormVisible = false;
        try {
            this.isLoading = true;
            const result = await this.confirmationResult.confirm(this.code);
            // User has successfully signed in to firebase.
            this.uid = result.user.uid;
            let userSnap = await db.collection("users").doc(this.uid).get();
            // Korisnik postoji (u kolekciji users)
            if (userSnap.exists) {
                commonStore.user = userSnap.data() as any;

                // I) ako ima popunjen orgId
                if (commonStore.user.orgId !== "") {
                    await this.isUserSalesRep();
                } else {// II) ako nema popunjen orgId                    
                    let joinRequestsSnap = await db.collection("join_requests")
                        .where('userId', '==', this.uid)
                        .where('isResolved', '==', false)
                        .limit(1)
                        .get();
                    if (!joinRequestsSnap.empty) {
                        let user = joinRequestsSnap.docs[0].data();
                        const organizationSnap = await db.collection("organizations").doc(user.orgId).get();
                        let organization = organizationSnap.data();

                        this.fullName = user.fullName;
                        this.phoneNumber = user.phoneNumber;
                        this.taxId = organization.taxId;
                        this.organizationName = organization.name;

                        this.isPhoneNumberFormVisible = false;
                        this.isCodeFormVisible = false;
                        this.isRegistrationFormVisible = true;
                        this.isSearchTaxIdVisible = false;
                        this.isJoinOrganizationVisible = true;
                        this.isRegisterAndJoinOrganizationButtonDisabled = true;
                        this.isLoading = false;
                        history.push("/register");
                        //commonStore.user.orgId = organization.id;
                        //await this.isUserSalesRep();
                    } else {
                        // dajemo korisniku opciju da se registruje TJ UNOSI SAMO PIB !!!!!!!!!!!!!!!!!!!!!!!!!
                        // U formi za registraciju unosi PIB
                        // Proveravamo da li navedeni PIB postoji u nekom od dokumenata u kolekciji /organizations/{orgId}
                        // Ako postoji, prikažemo naziv organizacije, PIB, i adresu, a korisnik dobije dugme kojim može da pošalje zahtev za pristup organizaciji i još jedno dugme za izmenu unetih podataka, tj. PIB-a da bi ponovio postupak
                        // Kada korisnik pritisne "Pristupi organizaciji", kreira se novi dokument u kolekciji /invitations/{invitationId} /join_requests/{joinRequestId} sa atributima kao u /join_requests/QCxOVhu9iHd026jPyLa5
                        // Kada korisnik pritisne "Izmeni podatke", ponovo se otvori forma za registraciju
                        // Korisnik moze da pritisne i "Odustani" u kom slucaju se vraca na pocetni ekran
                        // Ako ne postoji, prikažemo poruku - Vaša organizacija nije registrovana, molimo Vas posetite mdistribution.mprocesses.com i registrujte svoj nalog ili kontaktirajte Vašeg poslodavca
                        //this.isRegistrationFormVisible = true;
                        this.isLoading = false;
                        history.push("/register");
                    }
                }
            } else {
                if (this.type === "login") {
                    // Ako korisnik ne postoji u kolekciji users
                    toastr.error(Messages.USER_DOSE_NOT_EXIST);
                    //this.onSignOut();
                    history.push("/register");
                }
                else if (this.type === "register") {
                    this.isPhoneNumberFormVisible = false;
                    this.isCodeFormVisible = false;
                    this.isRegistrationFormVisible = true;
                    this.isSearchTaxIdVisible = true;
                    this.isJoinOrganizationVisible = false;
                    this.isLoading = false;
                }
            }
        }
        catch (error) {
            this.isLoading = false;
            console.log(error);
            toastr.error(Messages.INVALID_SMS_CODE);
        };
    };

    onSignOut = async () => {
        try {
            await firebase.auth().signOut();
            localStorage.removeItem("userId");
            localStorage.removeItem("favoriteArticles");
            commonStore.setLocalStorageItem("isUserLoggedIn", "false");
            history.push("/");
            this.reset();
        } catch (error) {
            console.error("Error siging out: ", error);
        };
    }

    @action validateRegistration = (): boolean => {
        let isValid: boolean = true;

        if (this.fullName.trim() === "") {
            this.fullNameMessage = Messages.REQUIRED_FIELD;
            isValid = false;
        }

        return isValid;
    }

    // onSaveRegistration = async (event): Promise<any> => {
    //     event.preventDefault();
    //     if (!this.validateRegistration()) return;

    //     this.isLoading = true;
    //     const usersResult = await db.collection("users").where('email', '==', this.vendorEmail).limit(1).get();
    //     if (!usersResult.empty) {
    //         const newUser: any = this.createUser();

    //         await db.collection('users')
    //             .doc(this.uid)
    //             .set(newUser);

    //         toastr.success(Messages.REGISTERED_SUCCESSFULY);
    //         history.push('/');
    //     }
    //     else {
    //         toastr.error(Messages.VENDOR_EMAIL_DOES_NOT_EXIST);
    //         history.push('/');
    //     }
    // }

    createUser = (): any => {
        const newUser: User = new User();
        newUser.registrationApp = "COMMERCIALIST";
        newUser.catalogId = null;
        newUser.fullName = this.fullName;
        newUser.id = this.uid;
        newUser.isActivated = false;
        newUser.phoneNumber = this.phoneNumber;
        newUser.orgId = "";
        newUser.salesRepMatchId = [];
        return { ...newUser };
    }

    /* ORGANIZATION */
    @action searchTaxId = async () => {
        const organizationSnap = await db.collection("organizations").where('taxId', '==', this.taxId).limit(1).get();
        if (organizationSnap.empty) {
            toastr.success(Messages.ORGANIZATION_IS_NOT_REGISTERED);
            this.taxId = "";
        } else {
            let organization = organizationSnap.docs[0].data();
            let joinRequestsSnap = await db.collection("join_requests")
                .where('userId', '==', this.uid)
                .where('orgId', '==', organization.id)
                .limit(1)
                .get();
            if (joinRequestsSnap.empty) {
                this.taxId = organization.taxId;
                this.orgId = organization.id;
                this.isSearchTaxIdVisible = false;
                this.isJoinOrganizationVisible = true;
                this.isRegisterAndJoinOrganizationButtonDisabled = false;
            } else {
                this.isRegisterAndJoinOrganizationButtonDisabled = true;
                toastr.success("Vec ste podneli zahtev za " + organization.name);
            }
        }
    }

    @action registerAndJoinOrganization = async () => {
        const usersResult = await db.collection("users").where('phoneNumber', '==', this.phoneNumber).limit(1).get();
        if (usersResult.empty) {
            const newUser: any = this.createUser();
            await db.collection('users')
                .doc(this.uid)
                .set(newUser);
        }

        await db.collection("join_requests").add({
            creationTimestamp: firebase.firestore.Timestamp.now(),
            fullName: this.fullName,
            isApproved: false,
            isResolved: false,
            orgId: this.orgId,
            phoneNumber: this.phoneNumber,
            resolvedTimestamp: "",
            userId: this.uid,

        });
        toastr.success(Messages.REGISTERED_SUCCESSFULY);
        history.push('/');
    }

    @action changeTaxId = () => {
        this.taxId = "";
        this.isSearchTaxIdVisible = true;
        this.isJoinOrganizationVisible = false;
    }

    @action reset = (): void => {
        this.phoneNumber = "";
        this.code = "";
        this.fullName = "";
        this.vendorEmail = "";
        this.confirmationResult = null;
        this.recaptchaVerifier = undefined;
        this.type = "";
        this.orgId = "";
        this.taxId = "";
        this.organizationName = "";

        this.isLoading = true;
        this.isPhoneNumberFormVisible = true;
        this.isCodeFormVisible = false;
        this.isRegistrationFormVisible = false;
        this.showWithdrawFromTheOrganizationButton = false;
        this.isJoinOrganizationVisible = false;
        this.isSearchTaxIdVisible = false;
        this.isRegisterAndJoinOrganizationButtonDisabled = false;

        this.phoneNumberMessage = "";
        this.codeMessage = "";
        this.fullNameMessage = "";
        this.vendorEmailMessage = "";
        this.taxIdMessage = "";
    }
}

export let loginStore = new LoginStore();